// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2b5C9","footer":"ModalError_footer__1ovdX"};